export { default as LocationFormComponent } from './location-form';
